import React from "react";
import "./update.scss";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";

const Update = () => {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    const getUpdate = async () => {
      try {
        const response = await axios.get("/get-updates");
        setUpdates(response.data.data.map((item) => item.update));
      } catch (error) {
        return;
      }
    };
    getUpdate();
  }, []);

  const updatesString = updates.join(" | ");

  return (
    <div className="update_wrp">
      <section className="ticker" role="region">
        <div className="ticker__label">Latest Update:</div>

        <div className="ticker__viewport">
          <div className="ticker__track">
            <span>{updatesString}</span>
            <span>{updatesString}</span>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Update;
